/* eslint-disable */
import Feature from 'api/auth/types/user/Feature';
import StorageKeys from 'constants/StorageKeys';
import LocalStorageService from './LocalStorageService';

class FeatureStorageService extends LocalStorageService {
  /**
   * Gets currently logged-in user's accessible features from local storage
   *
   * @returns {Array<Feature>} Features list
   */
  static GetUserFeatures = (): Array<Feature> =>
    this.GetItem<Array<Feature>>(StorageKeys.Features);
}

export default FeatureStorageService;
